import { useVaultEntriesQuery } from "modules/settings/hooks/useVaultEntriesQuery"
import { useMemo } from "react"

export function useVaultPreviewContext(context: Record<string, unknown>) {
  const { data: entries } = useVaultEntriesQuery()

  return useMemo(() => {
    const vault = Object.fromEntries(
      entries?.map((entry) => [entry.key, entry.isSecret ? "[secret]" : entry.value]) ?? [],
    )

    return { ...context, vault }
  }, [context, entries])
}
